import { render } from "./AddOrUpdateProductBasePriceExTank.html?vue&type=template&id=e68471ee&scoped=true"
import script from "./AddOrUpdateProductBasePriceExTank.js?vue&type=script&lang=js"
export * from "./AddOrUpdateProductBasePriceExTank.js?vue&type=script&lang=js"

import "./AddOrUpdateProductBasePriceExTank.css?vue&type=style&index=0&id=e68471ee&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e68471ee"]])

export default __exports__